import { useQuery } from "@tanstack/react-query";
import {
  getBusinessOperation,
  getBusinessOperationDetail,
} from "src/services/BusinessOperation.service";
import {
  BusinessOperationDetailRequestBody,
  BusinessOperationParams,
} from "./interfaces";
import { reactQueryOptions } from "src/config/reactQuery.config";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { AccessResource, ActionType } from "src/types/accessControl";

export const useGetBusinessOperation = (params: BusinessOperationParams) => {
  const isAllowedBusinessOperation = useGetAccessPermission({
    resource: AccessResource["Master Data - Business Operation"],
    action: ActionType["Read"],
  });
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["business-operation", params],
    queryFn: () => getBusinessOperation(params),
    enabled: isAllowedBusinessOperation
  });
};

export const useGetBusinessOperationDetail = (
  requestBody: BusinessOperationDetailRequestBody
) => {
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["business-operation-detail"],
    queryFn: () => getBusinessOperationDetail(requestBody),
  });
};
